import billingsTranslationsHelper from "../../../../../../languages/billings-translations.helper";
import BillingsTaxiDriverContributionBonus, {
  BillingsTaxiDriverContributionBonusType,
} from "./types/billings-taxi-driver-contributions-bonus";

const getBonusNewContribution = (): BillingsTaxiDriverContributionBonus => {
  return {
    type: null,
    distance: null,
    rate: 0,
    amount: 0,
    comment: "",
  };
};

const getContributionTypeTranslation = (
  contributionType: BillingsTaxiDriverContributionBonusType | null
) => {
  const translations =
    billingsTranslationsHelper.getTaxiDriverContributionsTranslations().bonus
      .type;

  switch (contributionType) {
    case BillingsTaxiDriverContributionBonusType.BONUS_FAVORABLE_DISTANCE:
      return translations.favorableDistance;
    case BillingsTaxiDriverContributionBonusType.BONUS_OTHER:
      return translations.other;
  }
};

const billingsTaxiDriverContributionsBonusHelper = {
  getBonusNewContribution,
  getContributionTypeTranslation,
};

export default billingsTaxiDriverContributionsBonusHelper;
